import { render } from "./ExpiredPoints.vue?vue&type=template&id=4bae4572&scoped=true&ts=true"
import script from "./ExpiredPoints.vue?vue&type=script&lang=ts"
export * from "./ExpiredPoints.vue?vue&type=script&lang=ts"

import "./ExpiredPoints.vue?vue&type=style&index=0&id=4bae4572&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bae4572"]])

export default __exports__